export default __webpack_public_path__ + "static/media/Client_Consent_Form-Cells.5ca1ca29.pdf";